import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const reportCardsApi = {
  getSessions: (studentId) => api.get(`/report-cards/students/${studentId}/sessions`).then(unwrap),
  getCard: (studentId, sessionId) => api.get(`/report-cards/students/${studentId}/sessions/${sessionId}`).then(unwrap),
  downloadCard: (studentId, sessionId) =>
    api.get(`/report-cards/students/${studentId}/sessions/${sessionId}/download`, { responseType: 'blob' }),
  getMarksheet: (studentId, examId) =>
    api.get(`/report-cards/students/${studentId}/exams/${examId}`).then(unwrap),
  downloadMarksheet: (studentId, examId) =>
    api.get(`/report-cards/students/${studentId}/exams/${examId}/download`, { responseType: 'blob' }),
}
